import { type Observable, timeout, first, shareReplay  } from "rxjs";

export function getCachedRequest<T>(
  request: Observable<T>,
  signature: string,
  cache: Map<string, Observable<T>>,
  writeRequestEvent$: Observable<unknown>,
  refCount = false,
  cacheTime = 15 * 60 * 1000,
): Observable<T> {
  let cached = cache.get(signature);
  if (!cached) {
    cached = request.pipe(
      shareReplay({
        refCount,
        bufferSize: 1,
        windowTime: cacheTime,
      }),
    );
    cache.set(signature, cached);

    writeRequestEvent$.pipe(
      first(),
      timeout(cacheTime)
    ).subscribe({
      next: () => cache.delete(signature),
      error: () => cache.delete(signature),
    });
  }
  return cached;
}